import { useCart } from '@emico-hooks/cart'

export default function useCartItemsAmount() {
    const { data } = useCart()

    return data?.totalQuantity ?? 0
}
